import React from 'react';

const OurServices = () => {
  return (
    <section className="home-our-services">
      <div className="container-lg inner-container">
        <h4 className="top-head">Our Services</h4>
        <h2 className="top-head-l1">Growth Oriented <span className="c-primary1">B2B Digital Marketing Services.</span></h2>
        <h5 className="top-head-l2"><i>We’re in the business of making your business grow.</i></h5>
        <div className="row">
          <div className="col-xl-11">
            <p className="top-head-l3">We nerd out on crafting high-quality content that builds trust in your prospects. We dive into engaging conversations across every channel, making sure your message is heard and considered. And we actively seek out and identify opportunities
              to enable faster conversions.</p>
          </div>
        </div>

        <div className="row hm-ser-rw">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-4 col-xl-3">
              <div className="hm-blx">
                <div className={`icon-list icnss ${service.iconClass}`}></div>
                <h5>{service.title}</h5>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const services = [
  {
    iconClass: 'account-bsd-maketing-icn',
    title: 'Account-Based Marketing (ABM)',
    description: 'We tailor and target marketing strategies directly to key accounts, ensuring a personalized approach that resonates with each specific prospect.'
  },
  {
    iconClass: 'content-maketing-icn',
    title: 'Content Marketing',
    description: 'Our team excels at creating engaging, informative content that captures your brand\'s voice and appeals directly to your target audience\'s needs and interests.'
  },
  {
    iconClass: 'lead-icn',
    title: 'Lead Generation',
    description: 'We deploy innovative tactics to identify, attract and convert qualified prospects, turning interest into actionable leads for your business.'
  },
  {
    iconClass: 'wdd-icn',
    title: 'Website Design & Development',
    description: 'Our websites aren\'t just visually stunning; they\'re strategically engineered to enhance user experience and drive conversions.'
  },
  {
    iconClass: 'seo-icn',
    title: 'Search Engine Optimization (SEO)',
    description: 'We optimize your online presence for top search engine rankings, increasing your visibility and drawing more traffic to your site.'
  },
  {
    iconClass: 'smm-icn',
    title: 'Social Media Marketing',
    description: 'Through strategic social media campaigns, we connect your brand with the right audience, fostering engagement and building community.'
  },
  {
    iconClass: 'em-icn',
    title: 'Email Marketing',
    description: 'We design email marketing campaigns that deliver your message directly to your audience\'s inbox, with content that encourages opens, reads, and actions.'
  },
  {
    iconClass: 'pa-icn',
    title: 'Paid Advertising',
    description: 'Our paid advertising strategies are precisely targeted and data-driven, ensuring maximum ROI for your ad spend.'
  },
  {
    iconClass: 'ma-icn',
    title: 'Marketing Automation',
    description: 'We streamline your marketing processes with automation, ensuring efficient, consistent, and personalized communication with your audience.'
  },
  {
    iconClass: 'pm-icn',
    title: 'Program Management',
    description: 'Our comprehensive program management ensures that every aspect of your marketing campaign is meticulously planned, executed, and monitored for success.'
  }
];

export default OurServices;
